import React, { useState, useEffect } from "react";
import "./conditionAssessment.scss";
import ArtifactCard from "./ArtifactCard";
import { CiCircleMinus } from "react-icons/ci";
import { Accordion, Form, Modal } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { TbEdit } from "react-icons/tb";
import { Tooltip } from "@mui/material";
import { listMaterialDropdown } from "../../api/actions/material";
import { materialLoadOptionHandler } from "../../components/common/Common/utils/materialDropdown";
import Select from "react-select";
import { AiOutlineCloudSync } from "react-icons/ai";
import Fileurl from "../objectPhotography/Fileurl";
import { components } from "react-select";
import { checkPermission } from "../../helpers/permissions";
import toast from "react-hot-toast";

const ConditionAssessment = ({
  updateS3,
  setUpdateS3,
  technicalImages,
  setShowS3Gallery,
  setUpdate,
  update,
  strategicDetailsAddHandler,
  formik,
  stratigraphicAddhandler,
  changeStratNameHandler,
  stratNameChangeHandler,
  stratRef,
  conditionDegradationChangeHandler,
  removeStratighicHandler,
  conditionDegradationBlur,
  strategicDetailRemoveHandler,
  strategicEvidenceImageAddHandler,
  strategicEvidenceImageChangeHandler,
  setShowEnlargeImage,
  removestrategicEvidenceImageChangeHandler,
  setIsAutoSave,
  fromTable,
  titleRowRef,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [layerName, setLayerName] = useState("");
  const [isLayerNameValid, setIsLayerNameValid] = useState(false);
  const [material, setMaterial] = useState([]);
  const [s3modal, setS3modal] = useState({ show: false });
  const [defaultMaterial, setDefaultMaterial] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user_info"));

  const handleCreateLayer = () => {
    if (!layerName.trim()) return;
    alert(`Layer "${layerName}" created! (Mock action)`);
    setLayerName("");
  };

  const handleConditionChange = (selectedOptions, stratIndex) => {
    setIsAutoSave(true);
    const updatedStratigraphic = [...formik.values.stratigraphic_assessment];
    if (selectedOptions?.label === "Emergency") {
      updatedStratigraphic[stratIndex].assessment_is_emergency = true;
      updatedStratigraphic[stratIndex].assessment_stability = "";
    } else {
      updatedStratigraphic[stratIndex].assessment_stability =
        selectedOptions?.value;
      updatedStratigraphic[stratIndex].assessment_is_emergency = false;
    }
    updatedStratigraphic[stratIndex].selectedStability = selectedOptions;
    formik.setValues({
      ...formik.values,
      stratigraphic_assessment: updatedStratigraphic,
    });
  };

  const handleMaterialChange = (selectedOptions, stratIndex) => {
    setIsAutoSave(true);
    const updatedStratigraphic = [...formik.values.stratigraphic_assessment];
    updatedStratigraphic[stratIndex].assessment_materials =
      selectedOptions?.map((item) => item.value);
    updatedStratigraphic[stratIndex].selectedMaterial = selectedOptions;
    formik.setValues({
      ...formik.values,
      stratigraphic_assessment: updatedStratigraphic,
    });
  };

  const MultiValueLabel = (props) => {
    return (
      <components.MultiValueLabel
        {...props}
        innerProps={{
          ...props.innerProps,
          title: props.data.label, // 👈 full text on hover
        }}
      />
    );
  };

  useEffect(() => {
    listMaterialDropdown({
      page: 1,
      limit: 10,
      museum_id: userData?.museum,
      sort_by: "material_name",
    })((response) => {
      if (response?.status) {
        setMaterial(response?.data);
        setDefaultMaterial(response?.data);
      }
    });
  }, []);

  return (
    <div className="layer-manager">
      {/* Header Section */}
      <div className="layer-manager__header">
        <h1 className="layer-manager__title">Add condition assessment</h1>
        <div className="layer-manager__input-wrapper">
          <div style={{ width: "350px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Form.Control
                style={{
                  fontSize: "16px",
                  color: "black",
                }}
                type="text"
                placeholder="Condition assessment"
                value={layerName}
                onChange={(e) => {
                  e.stopPropagation();
                  if (e.target.value.trim()) {
                    setIsLayerNameValid(false);
                  }
                  setLayerName(e.target.value);
                }}
                className="layer-manager__input"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (layerName.trim()) {
                      stratigraphicAddhandler(layerName);
                      setLayerName("");
                    } else {
                      setIsLayerNameValid(true);
                    }
                  }
                }}
                isInvalid={isLayerNameValid}
              />
              <Tooltip title="Add condition assessment">
                <div
                  onClick={() => {
                    if (layerName.trim()) {
                      stratigraphicAddhandler(layerName);
                      setLayerName("");
                    } else {
                      setIsLayerNameValid(true);
                    }
                  }}
                  className="layer-manager__create-btn"
                >
                  <svg
                    style={{
                      cursor: "pointer",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                  >
                    <path
                      d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                      fill="#20409A"
                    />
                    <circle
                      cx="13.5"
                      cy="13.5"
                      r="12.75"
                      stroke="#20409A"
                      stroke-width="1.5"
                    />
                  </svg>{" "}
                </div>
              </Tooltip>
            </div>
            {isLayerNameValid && (
              <div style={{ color: "red" }}>
                <p style={{ fontSize: "13px" }}>Required</p>
              </div>
            )}
          </div>
          <div>
            <Tooltip
              title={
                checkPermission(["cloud_sync"])
                  ? "Sync with cloud and open gallery"
                  : "Open gallery"
              }
            >
              <div
                style={{
                  cursor: "pointer",
                  marginRight: "10px",
                  backgroundColor: "#20409a",
                  borderRadius: "6px",
                  padding: "6px",
                }}
                onClick={() => {
                  if (technicalImages?.length === 0) {
                    toast.error("No images in gallery");
                  }
                  if (checkPermission(["cloud_sync"])) {
                    setS3modal({
                      show: true,
                    });
                  }
                  setShowS3Gallery(true);
                }}
              >
                <AiOutlineCloudSync
                  style={{
                    color: "#fff",
                    fontSize: "27px",
                  }}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      {/* Main Content Area */}
      {formik.values.stratigraphic_assessment?.length > 0 ? (
        formik.values.stratigraphic_assessment?.map((stratdata, stratIndex) => (
          <Accordion className="layer-manager__content">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="condition-layer-accordiion-header">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",

                    // backgroundColor: "#D8EDFF",
                  }}
                >
                  {/* LEFT SECTION */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "28px",
                      flexWrap: "wrap",
                      flex: 1,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Layer Label */}
                    <Tooltip
                      title={
                        stratdata?.doubleClickActive ? null : "Edit section"
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="edit-assessment-name-container"
                        onClick={(e) => {
                          changeStratNameHandler(stratIndex);
                          e.stopPropagation();
                        }}
                      >
                        {stratdata?.doubleClickActive ? (
                          <Form.Control
                            placeholder="Condition assessment"
                            ref={stratRef}
                            value={stratdata?.assessment_name}
                            onChange={(e) =>
                              stratNameChangeHandler(e.target.value, stratIndex)
                            }
                          />
                        ) : (
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              fontSize: "16px",
                            }}
                          >
                            {stratdata?.assessment_name}
                          </span>
                        )}
                        {!stratdata?.doubleClickActive && (
                          <TbEdit color="#20409a" />
                        )}
                      </div>
                    </Tooltip>

                    {/* Dropdowns Wrapper */}
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                      onClick={(e) => e.stopPropagation()} // prevent accordion toggle
                    >
                      {/* --- Dropdown 1 --- */}
                      {fromTable ? (
                        <AsyncSelect
                          defaultOptions={material}
                          loadOptions={(e) =>
                            materialLoadOptionHandler(
                              e,
                              userData,
                              setDefaultMaterial
                            )
                          }
                          components={{ MultiValueLabel }}
                          isMulti
                          className="condition-assessment-select"
                          classNamePrefix="condition-assessment-select"
                          closeMenuOnScroll={(event) => {
                            return (
                              !event.target.classList.contains(
                                "condition-assessment-select__menu-list"
                              ) &&
                              !event.target.classList.contains(
                                "condition-assessment-select__value-container"
                              )
                            );
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          value={stratdata?.selectedMaterial}
                          onChange={(e) => handleMaterialChange(e, stratIndex)}
                          placeholder="Materials"
                          styles={{
                            valueContainer: (base) => ({
                              ...base,
                              maxHeight: 60,
                              overflowY: "auto",
                            }),

                            option: (base) => ({
                              ...base,
                              color: "black",
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      ) : (
                        <AsyncSelect
                          defaultOptions={material}
                          loadOptions={(e) =>
                            materialLoadOptionHandler(
                              e,
                              userData,
                              setDefaultMaterial
                            )
                          }
                          components={{ MultiValueLabel }}
                          isMulti
                          className="condition-assessment-select"
                          menuPortalTarget={document.body}
                          value={stratdata?.selectedMaterial}
                          onChange={(e) => handleMaterialChange(e, stratIndex)}
                          placeholder="Materials"
                          styles={{
                            valueContainer: (base) => ({
                              ...base,
                              maxHeight: 60,
                              overflowY: "auto",
                            }),

                            option: (base) => ({
                              ...base,
                              color: "black",
                            }),
                          }}
                        />
                      )}

                      {/* --- Dropdown 2 --- */}
                      {fromTable ? (
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            control: (base) => ({
                              ...base,
                              width: 150,
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            option: (base) => ({
                              ...base,
                              color: "black",
                            }),
                          }}
                          options={[
                            {
                              value: 1,
                              label: 1,
                            },
                            {
                              value: 2,
                              label: 2,
                            },
                            {
                              value: 3,
                              label: 3,
                            },
                            {
                              value: "Emergency",
                              label: "Emergency",
                            },
                          ]}
                          value={
                            stratdata?.assessment_is_emergency
                              ? { value: "Emergency", label: "Emergency" }
                              : stratdata?.assessment_stability
                              ? {
                                  value: stratdata.assessment_stability,
                                  label: stratdata.assessment_stability,
                                }
                              : null // 👈 IMPORTANT
                          }
                          onChange={(e) => handleConditionChange(e, stratIndex)}
                          placeholder="Condition "
                          classNamePrefix="condition-assessment-select"
                          closeMenuOnScroll={(event) => {
                            return (
                              !event.target.classList.contains(
                                "condition-assessment-select__menu-list"
                              ) &&
                              !event.target.classList.contains(
                                "condition-assessment-select__value-container"
                              )
                            );
                          }}
                        />
                      ) : (
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            control: (base) => ({
                              ...base,
                              width: 150,
                            }),
                            option: (base) => ({
                              ...base,
                              color: "black",
                            }),
                          }}
                          options={[
                            {
                              value: 1,
                              label: 1,
                            },
                            {
                              value: 2,
                              label: 2,
                            },
                            {
                              value: 3,
                              label: 3,
                            },
                            {
                              value: "Emergency",
                              label: "Emergency",
                            },
                          ]}
                          value={
                            stratdata?.assessment_is_emergency
                              ? { value: "Emergency", label: "Emergency" }
                              : stratdata?.assessment_stability
                              ? {
                                  value: stratdata.assessment_stability,
                                  label: stratdata.assessment_stability,
                                }
                              : null // 👈 IMPORTANT
                          }
                          onChange={(e) => handleConditionChange(e, stratIndex)}
                          placeholder="Condition "
                        />
                      )}
                    </div>
                  </div>

                  {/* RIGHT SECTION: MINUS ICON */}
                  <Tooltip title="Remove condition assessment">
                    <div
                      style={{
                        cursor: "pointer",
                        padding: "4px 6px",
                      }}
                      className="remove-strat-icon"
                      onClick={(e) => {
                        removeStratighicHandler(stratIndex);
                        e.stopPropagation(); // stop accordion toggle
                      }}
                    >
                      <CiCircleMinus color="#20409a" size={31} />
                    </div>
                  </Tooltip>
                </div>
              </Accordion.Header>
              <Accordion.Body
                style={{ marginLeft: "15px" }}
                className="layer-manager-body"
              >
                <div className="layer-manager__artifacts">
                  <div className="add-strat-icon">
                    <Tooltip title="Add degradation">
                      <svg
                        onClick={() => strategicDetailsAddHandler(stratIndex)}
                        style={{
                          cursor: "pointer",
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                      >
                        <path
                          d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                          fill="#20409A"
                        />
                        <circle
                          cx="13.5"
                          cy="13.5"
                          r="12.75"
                          stroke="#20409A"
                          stroke-width="1.5"
                        />
                      </svg>
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      marginTop: "15px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "3rem",
                    }}
                  >
                    {stratdata?.assessment_details?.map(
                      (artifact, artifactIndex, arr) => (
                        <ArtifactCard
                          setIsAutoSave={setIsAutoSave}
                          artifactArray={arr}
                          removestrategicEvidenceImageChangeHandler={
                            removestrategicEvidenceImageChangeHandler
                          }
                          setShowEnlargeImage={setShowEnlargeImage}
                          strategicDetailRemoveHandler={
                            strategicDetailRemoveHandler
                          }
                          strategicEvidenceImageAddHandler={
                            strategicEvidenceImageAddHandler
                          }
                          strategicEvidenceImageChangeHandler={
                            strategicEvidenceImageChangeHandler
                          }
                          strategicDetailsAddHandler={
                            strategicDetailsAddHandler
                          }
                          formik={formik}
                          conditionDegradationBlur={conditionDegradationBlur}
                          stratData={stratdata}
                          stratIndex={stratIndex}
                          artifactIndex={artifactIndex}
                          conditionDegradationChangeHandler={
                            conditionDegradationChangeHandler
                          }
                          key={artifact.id}
                          artifact={artifact}
                        />
                      )
                    )}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))
      ) : (
        <></>
      )}
      <Modal
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="category-view-modal s3-modal s3-conservation-modal"
        show={s3modal.show}
        onHide={() => setS3modal({ show: false })}
      >
        <Modal.Header className="detail-view-header" closeButton>
          <Modal.Title>Sync with cloud</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "150px",
            }}
          >
            <Fileurl
              fromConservationDetail={true}
              updateS3={updateS3}
              setUpdateS3={setUpdateS3}
              update={update}
              setUpdate={setUpdate}
              detail={true}
              accession_number={
                formik?.values?.object_details?.accession_number
              }
              setS3modal={setS3modal}
              fromConservation={true}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConditionAssessment;
